export interface ISlotViewItem {
  id?: string
  gameId: string
  description: string
  format?: string
  gameName: string
  sectionId?: string
  tab: string[]
  tabLive: string[]
  provider: string
  imageUrl: string
  imageUrlWide?: string
  routeProvider: string
  isDefault?: boolean
  technologyId?: string | number
  gameUrl?: string
  hasDemoMode?: boolean
  hasFreeSpins?: boolean
  isLiveGame?: boolean
  additionalData?: any
  additionalIntegrationGameId?: string
  gameType?: string
  isHide?: boolean
}

export interface ITabs {
  [key: string]: string[]
}

export type ISlotsGameType =
  | 'casino'
  | 'live-casino'
  | 'amatic'
  | 'star-casino'
  | 'virtual'
  | 'free-spin'
  | 'tv-games'
  | 'mini-games'
  | 'wagering'

export enum SlotsGameType {
  casino = 'casino',
  liveCasino = 'live-casino',
  virtual = 'virtual',
  tvGames = 'tv-games',
  freeSpin = 'free-spin',
  wagering = 'wagering',
}

export type ExternalGamesType = 'top' | 'new' | 'wager' | 'categories'

export interface ITopSlotsDTO {
  games: string[]
}

export interface INewGamesDTO {
  games: string[]
}

export interface IWagerGamesDTO {
  games: string[]
}

export interface ICategoryGamesItem {
  name: string
  games: string[]
}

export type CategoriesGames = Record<string, ICategoryGamesItem>

export interface ExternalGamesBase {
  lastLoadDate: Date | null
  games: string[]
}

export interface ExternalGamesCategories {
  lastLoadDate: Date | null
  categoriesData: CategoriesGames
}

export type ExternalGamesRecord = {
  [K in ExternalGamesType]: K extends 'categories' ? ExternalGamesCategories : ExternalGamesBase
}
